(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('talentSidebarToggle', talentSidebarToggle);

    function talentSidebarToggle() {
        return {
            restrict: 'A',
            link: link
        };

        function link(scope, elem) {
            elem.on('click', function() {
                if (elem.hasClass('active')) {
                    angular.element('.sidebar-wrapper').removeClass('active');
                    elem.removeClass('active');
                } else {
                    angular.element('.sidebar-wrapper').addClass('active');
                    elem.addClass('active');
                }

            });
        }
    }
})();